import {Component, Input, OnInit, SecurityContext} from '@angular/core';
import {Router} from "@angular/router";

@Component({
	selector: 'app-accordion-landing',
	templateUrl: './accordion-landing.component.html',
	styleUrls: ['./accordion-landing.component.scss']
})
export class AccordionLandingComponent implements OnInit {
	@Input() info: AccordionInfo;
	protected readonly SecurityContext = SecurityContext;

	constructor(private router: Router) {
	}

	ngOnInit() {
	}

	toggleAccordion() {
		this.info.open = !this.info.open;
	}

}

class AccordionInfo {
	icon: string;
	name: string;
	description: string;
	router?: string;
	open: boolean;
}
